"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAPIConnectionError = exports.ERROR_MESSAGES = void 0;
exports.ERROR_MESSAGES = {
    noAPIConnection: 'There seems to be no connection to the API. Make sure the API is reachable.',
};
class NoAPIConnectionError extends Error {
}
exports.NoAPIConnectionError = NoAPIConnectionError;
//# sourceMappingURL=errors.js.map